import { useAuth } from "../hooks/useAuth";
import { Toast } from "./Toast";

/**
 * Tells the person when this tab followed the browser's session to another
 * account, or was signed out with it (hooks/useAuth.jsx). It stays until it
 * is closed: it explains why the page changed under them.
 */
export function SessionNotice() {
  const { sessionNotice, dismissSessionNotice } = useAuth();
  if (!sessionNotice) return null;
  return (
    <Toast
      type="warning"
      title={sessionNotice.title}
      message={sessionNotice.message}
      onClose={dismissSessionNotice}
      duration={0}
    />
  );
}
